import clsx from "clsx";
import "./CardInfoDoctorModalContent.scss";

type CardInfoDoctorModalContentProps = {
  overrideClassNames?: string;
  children?: React.ReactNode;
};

export const CardInfoDoctorModalContent = ({
  overrideClassNames,
  children,
}: CardInfoDoctorModalContentProps) => {
  return (
    <div className={clsx("ui-card-info-modal-body", overrideClassNames)}>
      {children}
    </div>
  );
};
